export default {
  countries: [
    "Afghanistan",
    "Aland Islands",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antigua & Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "The Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bonaire, Sint Eustatius and Saba",
    "Bosnia & Herzegovina",
    "Botswana",
    "Brazil",
    "British Indian Ocean Territory",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands",
    "Colombia",
    "Comoros",
    "Congo",
    "Democratic Republic of the Congo",
    "Cook Islands",
    "Costa Rica",
    "Cote D'Ivoire (IvoryCoast)",
    "Croatia",
    "Cuba",
    "Curacao",
    "Cyprus",
    "Nothern Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Falkland Islands",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Holy See (Vatican City State)",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Islamic Republic of Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Democratic People's Republic of North Korea",
    "South Korea (Republic of Korea)",
    "Kuwait",
    "Kyrgyzstan",
    "Lao People's Democratic Republic",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macau",
    "The Former Yugoslav Republic Of Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Federated States of Micronesia",
    "Republic of Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestinian Territory Occupied",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Reunion",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "Saint Barthelemy",
    "Saint Helena, Ascension and Tristan da Cunha",
    "Saint Kitts & Nevis",
    "Saint Lucia",
    "Saint Martin",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome & Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten (Dutch part)",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia and the South Sandwich Islands",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria Arab Republic",
    "Taiwan",
    "Tajikistan",
    "United Republic of Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad & Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks & Caicos",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Nations",
    "United Nations Agency",
    "United States Minor Outlying Islands",
    "United States of America",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela",
    "Vietnam",
    "U.S. Virgin Islands",
    "British Virgin Islands",
    "Wallis and Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe",
    "Stateless or refugee",
  ],
  user: {
    immigrationStatus: [
      "Tier 2 (General)",
      "Tier 2 (Intra-Company Transfer): Established Staff",
      "Tier 2 (Intra-Company Transfer): Graduate Trainee",
      "Tier 2 (Intra-Company Transfer): Long Term staff",
      "Tier 2 (Intra-Company Transfer): Short Term staff",
      "Tier 2 (Intra-Company Transfer): Skills Transfer",
      "Tier 2 (Minister of Religion)",
      "Tier 2 (Sportsperson)",
      "Start-up",
      "Innovator",
      "Global talent",
      "Tier 4 (General)",
      "Tier 1 (Entrepreneur)",
      "Tier 1 (Exceptional Talent)",
      "Tier 1 (General)",
      "Tier 1 (Graduate Entrepreneur)",
      "Tier 1 (Investor)",
      "Business and Commercial work permits",
      "Representative of an Overseas Business",
      "Representative of an Overseas Newspaper, News Agency or Broadcaster",
      "Science and Engineering Graduate Scheme",
      "International Graduates Scheme",
      "Other",
    ],
    titles: ["Mr", "Mrs", "Miss", "Ms", "Doctor", "Reverend"],
  },
  document: {
    check: {
      types: ["radio", "input"],
    },
  },
  case: {
    types: ["Sponsorship", "Compliance"],
    sponsorship: {
      job_titles: ["Artist", "Designer"],
    },
  },
  company: {
    types: [
      "Branch Office of an Overseas Company",
      "Central/Local Government Department; Body; Quango, Agency Public Body",
      "Charity",
      "Company Limited by Guarantee",
      "Company incorporated under the Industrial & Provident Societies Act 1968",
      "Hotel and/or Catering Establishment",
      "Incorporated by Royal Charter",
      "Limited Liability Partnership",
      "Limited Partnership",
      "Overseas Gov. Int.Organisation, Diplomatic Mission",
      "Partnership",
      "Private Individual",
      "Private Limited Company/ Limited Liability Company",
      "Public Limited Company",
      "Religious and/or Faith Body",
      "Representative Office of an Overseas Company",
      "Sole Trader",
      "Unlimited Company",
    ],
    sector: [
      "Accommodation and Food Service Activities",
      "Activities of extraterritorial organisations and bodies",
      "Activities of households as employers; production activities of household for own use",
      "Administrative and Support Service Activities",
      "Agriculture, Forestry and Fishing",
      "Arts, Entertainment and Recreation",
      "Construction",
      "Education",
      "Electricity, gas, stream and air conditioning supply",
      "Financial and insurance Activities",
      "Human Health and Social Work Activities",
      "Information and Communications",
      "Manufacturing",
      "Mining and Quarrying",
      "Other Service Activities",
      "Public Admin and defence; compulsory social security",
      "Professional, Scientific and Technical Activities",
      "Real Estate Activities",
      "Transportation and Storage",
      "Water supply; sewerage, waste management and remediation activities",
      "Wholesale and retail trade; repair of motor vehicles and motorcycles",
    ],
    operates: [
      "Company owns or leases your business premises",
      "Company operates from a co-working space",
      "Company operates virtually, so no business premisses",
    ],
    previous_decision: ["Rejected", "Refused", "Other"],
  },
  prefill_options: [
    "",
    "honorific-prefix",
    "given-name",
    "additional-name",
    "family-name",
    "email",
    "address-line1",
    "address-line2",
    "country-name",
    "postal-code",
  ],
};
